import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { THEMES } from './vendor/edge4ward-ui/stores/createThemeStore.js'

// Apply saved theme before first render (avoids flash)
const savedTheme = localStorage.getItem('edge4field-theme')
let parsed = null
try {
  parsed = savedTheme ? JSON.parse(savedTheme) : null
} catch {
  parsed = null
}
const initialTheme = THEMES.includes(parsed?.state?.theme) ? parsed.state.theme : 'field-blue'
document.documentElement.setAttribute('data-theme', initialTheme)

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
